import axios from '@axios'

const route = 'auth'

export default {
  namespaced: true,
  state: {
    user: {},
    photo: null,
    planList: [],
    warningSubscription: 'not',
  },
  getters: {
    getUser(state) {
      return state.user
    },
    getPhoto(state) {
      return state.photo
    },
    getPlanList(state) {
      return state.planList
    },
    getWarningSubscription(state) {
      return state.warningSubscription
    },
    getOnboardingDone(state) {
      return state.user?.onboarding_done ?? false
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setPhoto(state, photo) {
      state.photo = photo
    },
    setPlanList(state, planList) {
      state.planList = planList
    },
    setWarningSubscription(state, warningSubscription) {
      state.warningSubscription = warningSubscription
    },
  },
  actions: {
    // getAll(context,{itemsPerPage,page,search}) {
    //   return axios.get(route + '?page=' + page + '&items_per_page=' + itemsPerPage + '&search=' + search)
    // },

    login(context, card) {
      return axios.post(`${route}/login`, card)
    },

    googleRedirect(context) {
      return axios.get(`${route}/google/redirect`)
    },

    update(context, card) {
      return axios.put(`${route}/${card.id}`, card)
    },

    destroy(context, card) {
      return axios.delete(`${route}/${card.id}`)
    },
    logout(context) {
      return axios.post(`${route}/logout`)
    },
    checkToken(context, token) {
      return axios.post(`${route}/me`, { token })
    },

    // recuperar senha
    forgotPassword(context, email) {
      return axios.post(`${route}/password/forgot-password`, { email })
    },

    // enviar nova senha
    resetPassword(context, payload) {
      return axios.post(`${route}/password/reset`, payload)
    },

    test(context) {
      return axios.get(`test/printTerm`)
    },
    markOnboardingDone(context) {
      return axios.post(`auth/onboarding-done`).then(() => {
        context.commit('setUser', { ...context.state.user, onboarding_done: true })
      })
    },
  },
}
